import React from 'react'
import { filter, sumBy, uniqBy } from 'lodash'
import Table from 'UI/Table'

import { groupedCustomerData, groupedDomainData } from './Data'

const RDSColumn = (id) => ({
  id,
  type: 'number',
  accessor: ({ assets }) => sumBy(assets, id),
  Footer: ({ data }) => sumBy(data, id).toLocaleString()
})

const RDSTable = ({ data }) => (
  <Table {...{
    data: groupedCustomerData(filter(data, ['rds_license_server', 1])),
    filterable: true,
    columns: [
      { Header: 'Customer', accessor: 'customer_name', type: 'clientNameWithStatus' },
      { Header: 'Total devices', type: 'number', id: 'totalDevices', accessor: ({ assets }) => assets.length },
      { Header: 'Total Licenses', ...RDSColumn('total_licenses') },
      { Header: 'Issued Licenses', ...RDSColumn('issued_licenses') },
      // { Header: 'Active Licenses', type: 'number', id: 'active_licenses', accessor: ({ assets }) => sumBy(assets, 'active_licenses') },
      // { Header: 'Expired Licenses', type: 'number', id: 'expired_licenses', accessor: ({ assets }) => sumBy(assets, 'expired_licenses') }
    ],
    SubComponent: (row) => (
      <Table {...{
        data: groupedDomainData(row.original.assets),
        filterable: true,
        showPagination: false,
        defaultPageSize: row.original.assets.length,
        columns: [
          { Header: 'Domain', accessor: 'domain' },
          { Header: 'Total Domain Controllers', type: 'number', id: 'totalDomainControllers', accessor: ({ assets }) => assets.length },
          { Header: 'Total Licenses', ...RDSColumn('total_licenses') },
          { Header: 'Issued Licenses', ...RDSColumn('issued_licenses') },
          // { Header: 'Active Licenses', type: 'number', id: 'active_licenses', accessor: ({ assets }) => sumBy(assets, 'active_licenses') },
          // { Header: 'Expired Licenses', type: 'number', id: 'expired_licenses', accessor: ({ assets }) => sumBy(assets, 'expired_licenses') }
        ],
        SubComponent: (row) => (
          <Table {...{
            data: row.original.assets,
            filterable: true,
            showPagination: false,
            defaultPageSize: row.original.assets.length,
            columns: [
              { Header: 'Domain Controller', accessor: 'device_name' },
              { Header: 'Power', accessor: 'power_state', type: 'powerState' },
              { Header: 'Operating System', accessor: 'operating_system' },
              { Header: 'License Server', type: 'boolean', id: 'rds_license_server', accessor: ({ rds_license_server }) => Boolean(rds_license_server) },
              { Header: 'License Type', accessor: 'type_and_model' },
              { Header: 'Total Licenses', type: 'number', accessor: 'total_licenses' },
              { Header: 'Issued Licenses', type: 'number', accessor: 'issued_licenses' },
              // { Header: 'Active Licenses', type: 'number', accessor: 'active_licenses' },
              // { Header: 'Expired Licenses', type: 'number', accessor: 'expired_licenses' },
            ]
          }} />
        )
      }} />
    )
  }} />
)

export default RDSTable
